import React, { useContext, useState } from "react";
import { useDispatch } from "react-redux";
import BizinBackend from "../../../helpers/bizin_helper";
import { DF_OT0040Context } from "../context";
import NotificationModal from "../../../components/Common/NotificationModal";
import CardFlow from "../../../components/Common/CardFlow";
import CardContext from "../../../components/Common/CardContext";
import TableSimple from "../../../components/Dynamic/TableSimple";
import TranspaleStringToComponente from "../../../components/Dynamic/TranspaleStringToComponente";
import { isLoading } from "../../../store/layout/actions";
import ModalIframePage from "../../../components/Common/ModalIframePage";


function GridBody() {

  const dispatch = useDispatch(); 

  const { csrfToken, access_token, userProfile } = useContext(DF_OT0040Context);
  const [triggerType, setTriggerType] = useState([])
  const [showTable, setShowTable] = useState(false)
  const [triggerOnFilter, setTriggerOnFilter] = useState(false);

  const [preFilter, setPreFilter] = useState([]);
  const [preFilterEditNF, setPreFilterEditNF] = useState([]);
  const [dataViewStatus, setDataViewStatus] = useState([]);
  const [dataDF_OT0043, setDataDF_OT0043] = useState([]);
  const [modalEditableConfirm, setModalEditableConfirm] = useState(false)
  const [modalEditableSuccess, setModalEditableSuccess] = useState(false)
  const [modalEditStatusNF, setModalEditStatusNF] = useState(false)
  const [modalViewStatusNF, setModalViewStatusNF] = useState(false)
  const [paramsOnItem, setParamsOnItem] = useState({})

  const [openModalTimeline, setOpenModalTimeline] = useState(false)

  const [modalFlowDF_OT0044Success, setModalFlowDF_OT0044Success] = useState(false)
  const [modalFlowDF_OT0044, setModalFlowDF_OT0044] = useState(false)
  const [modalFlowDF_OT0042Success, setModalFlowDF_OT0042Success] = useState(false)
  const [modalFlowDF_OT0042, setModalFlowDF_OT0042] = useState(false)

  const handleTriggers = async (trigger) => {
    const params = trigger?.params?.split('&').reduce((acc, curr) => {
      const [key, value] = curr.split('=');
      acc[key] = value;
      return acc;
    }, {});

    setParamsOnItem(params)

    await handleViewStatusNF(params)
    
    if(trigger?.config?.type === "VIEW_STATUS_NF") setModalViewStatusNF(true)
    else if(trigger?.config?.type === "EDIT_STATUS_NF") {
      await handleDataDF_OT0043(params)
      setModalEditStatusNF(true)
    }
    else if(trigger?.config?.type === "EXEC_PROC" && trigger?.transaction_id === 'DF_OT0042') setModalFlowDF_OT0042(true)
    else if(trigger?.config?.type === "EXEC_PROC" && trigger?.transaction_id === 'DF_OT0044') setModalFlowDF_OT0044(true)
    else if(trigger?.config?.type === "VIEW_TIMELINE") await setOpenModalTimeline(true)
    setTriggerType(trigger)
  }

  const handleFilter = async () => {
    setShowTable(true);
    setTriggerOnFilter(true)
  }

  const handleEditStatusNF = async () => {
    setModalEditableConfirm(false)
    dispatch(isLoading(true));
    try {
      const resp = await BizinBackend.executeProcedure(
        {
          1: paramsOnItem.ID_Agendamento, //ID_Agendamento
          2: paramsOnItem.ID_Arquivo, //ID_Arquivo_Documento
          3: userProfile.ID_Usuario ,//ID_Usuario
          4: preFilterEditNF[0]?.["Filtro_Status"]?.value || null, //Status_Entrega_Fisica
          5: null, //Motivo_Entrega
          6: preFilterEditNF[0]?.["Observacoes"] || null, //Observacao_Entrega
          7: preFilterEditNF[0]?.["Filtro_Data"]?.value.split("/").reverse().join("-") || null //Data_Ocorrencia
        },
        "SRM_Agendamentos_Atualizar_Log_Entrega",
        csrfToken,
        access_token,
      );
      if(resp.success) {
        setModalEditStatusNF(false)
        setModalEditableSuccess(true)
      }
    } catch (error) {
      console.log("erro ao filtrar", error);
    } finally {
      dispatch(isLoading(false));
    }
  }

  const handleDataDF_OT0043 = async (params) => {
    dispatch(isLoading(true));
    try {
      const resp = await BizinBackend.executeProcedure(
        {
          1: userProfile.ID_Usuario, //ID_Usuario
          2: 'pt-BR', //Idioma
          3: params.ID_Agendamento || null, //ID_Agendamento
          4: params.ID_Arquivo || params.ID_Arquivo_Documento || null, //ID_Arquivo_Documento
        },
        "FRONT_Workspace_DF_OT0043_Cabecalho",
        csrfToken,
        access_token,
      );
      if(resp && resp.resultset_2) setDataDF_OT0043(resp );
      else setDataDF_OT0043([]);
    } catch (error) {
      console.log("erro ao filtrar", error);
    } finally {
      dispatch(isLoading(false));
    }
  }

  const handleViewStatusNF = async (params) => {
    dispatch(isLoading(true));
    try {
      const resp = await BizinBackend.executeProcedure(
        {
          1: userProfile.ID_Usuario, //ID_Usuario
          2: 'pt-BR', //Idioma
          3: params.ID_Agendamento || null, //ID_Agendamento
          4: params.ID_Arquivo || params.ID_Arquivo_Documento || null, //ID_Arquivo_Documento
        },
        "FRONT_Workspace_DF_OT0041_Visualizar",
        csrfToken,
        access_token,
      );
      if(resp && resp.resultset_1) setDataViewStatus(resp);
      else setDataViewStatus([]);
    } catch (error) {
      console.log("erro ao filtrar", error);
    } finally {
      dispatch(isLoading(false));
    }
  }

  const handleFlowDF_OT0044 = async () => {
    dispatch(isLoading(true));
    try {
      const resp = await BizinBackend.executeProcedure(
        paramsOnItem,
        triggerType?.config?.procName,
        csrfToken,
        access_token,
      );
      setModalFlowDF_OT0044(false)
      setModalFlowDF_OT0044Success(true)
    } catch (error) {
      console.log("erro ao filtrar", error);
    } finally {
      dispatch(isLoading(false));
    }
  }

  const handleFlowDF_OT0042 = async () => {
    dispatch(isLoading(true));
    try {
      const resp = await BizinBackend.executeProcedure(
        paramsOnItem,
        triggerType?.config?.procName,
        csrfToken,
        access_token,
      );
      setModalFlowDF_OT0042(false)
      setModalFlowDF_OT0042Success(true)
    } catch (error) {
      console.log("erro ao filtrar", error);
    } finally {
      dispatch(isLoading(false));
    }
  }

  return (
    <div className="vh-100 p-0">
      <div className="bg-white mb-3 card-content shadow-card p-4">
          <div className="row d-flex align-items-center p-0 px-4 column-gap-3">
            <div className="col-12 col-md-2 col-lg-2 p-0">
              <TranspaleStringToComponente
                elementId={"Status_Agendamento"}
                elementProps={{
                  value: '',
                  type: 'Combobox',
                  title: "Status do Agendamento",
                  id: "Filtro_Status_Agendamento",
                  dataOptions: [
                      { label: "Selecionar", value: null },
                      { label: "Aprovado", value: "A" },
                      { label: "Cancelado", value: "C" },
                      { label: "Pendente", value: "P" },
                      { label: "Rejeitado", value: "R" },
                      { label: "Vencido", value: "V" },
                      { label: "Pré Agenda Expirada", value: "X" },
                      { label: "Pré Agenda Atendida", value: "Z" }
                  ]
                }}
                preFilter={preFilter}
                onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
              />              
            </div>
            <div className="col-12 col-md-3 col-lg-2 p-0 form-custom01-filter">
              <TranspaleStringToComponente
                elementId={"Data_Inicio"}
                elementProps={{
                  value: new Date().toLocaleDateString(),
                  type: 'Date',
                  title: "De",
                  id: "Filtro_Data_Inicio",
                }}
                preFilter={preFilter}
                onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
              />
            </div>            
            <div className="col-12 col-md-3 col-lg-2 p-0">
              <TranspaleStringToComponente
                elementId={"ID_Empresa_Origem"}
                elementProps={{
                  value: '',
                  type: 'Combobox',
                  title: "Empresa Origem",
                  id: "Filtro_ID_Empresa_Origem",
                  isDisabled: false,
                  procedure: "FRONT_Componente_Combo_Empresas",
                  procedureParams: [userProfile?.ID_Usuario, 'pt-BR', 'ORIGEM', 'NF']
                }}
                preFilter={preFilter}
                onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
              />
            </div>
            <div className="col-12 col-md-2 p-0">
              <TranspaleStringToComponente
                elementId={"ID_Planta_Origem"}
                elementProps={{
                  value: '',
                  type: 'Combobox',
                  title: "Planta Origem",
                  id: "Filtro_ID_Planta_Origem",
                  isDisabled: false,
                  procedure: "FRONT_Componente_Combo_Plantas",
                  procedureParams: [userProfile?.ID_Usuario, 'pt-BR', '<#Filtro_ID_Empresa_Origem#>', 'ORIGEM', 'NF'],
                  alienated: ["Filtro_ID_Empresa_Origem"]
                }}
                preFilter={preFilter}
                onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
              />
            </div>
            <div className="col p-0 form-custom01-filter">
                <TranspaleStringToComponente
                  elementId={"Numero_Protocolo"}
                  elementProps={{
                    value: '',
                    type: 'Input',
                    placeholder: 'Digitar',
                    title: "Número Protocolo",
                    id: "Filtro_Numero_Protocolo"
                  }}
                  preFilter={preFilter}
                  onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                />
              </div>
            <div className="col-12 col-md-1"></div>
          </div>
            <div className="row d-flex align-items-center p-0 px-4 column-gap-3">
              <div className="col-12 col-md-2 p-0">
                <TranspaleStringToComponente
                    elementId={"Status_Documento"}
                    elementProps={{
                      value: '',
                      type: 'Combobox',
                      title: "Status do Documento",
                      id: "Filtro_Status_Documento",
                      dataOptions: [
                        { label: "Selecionar", value: null },
                        { label: "Realizada / Entrega Total", value: "S" },
                        { label: "No Show", value: "N" },
                        { label: "Devolução Parcial", value: "R" },
                        { label: "Devolução Total", value: "T" },
                        { label: "Pendentes", value: "P" }
                      ]
                    }}
                    preFilter={preFilter}
                    onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                  />
              </div>
              <div className="col-12 col-md-2 p-md-0 p-0 form-custom01-filter">
                <TranspaleStringToComponente
                  elementId={"Data_Fim"}
                  elementProps={{
                    value: new Date().toLocaleDateString(),
                    type: 'Date',
                    title: "Até",
                    id: "Filtro_Data_Fim",
                  }}
                  preFilter={preFilter}
                  onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                />
              </div>
              <div className="col-12 col-md-2 p-md-0 p-0">
                <TranspaleStringToComponente
                  elementId={"ID_Empresa_Destino"}
                  elementProps={{
                    value: '',
                    type: 'Combobox',
                    title: "Empresa Destino",
                    id: "Filtro_ID_Empresa_Destino",
                    isDisabled: false,
                    procedure: "FRONT_Componente_Combo_Empresas",
                    procedureParams: [userProfile?.ID_Usuario, 'pt-BR', 'DESTINO', 'NF']
                  }}
                  preFilter={preFilter}
                  onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                />
              </div>
              <div className="col-12 col-md-2 p-md-0 p-0">
                <TranspaleStringToComponente
                  elementId={"ID_Planta_Destino"}
                  elementProps={{
                    value: '',
                    type: 'Combobox',
                    title: "Planta Destino",
                    id: "Filtro_ID_Planta_Destino",
                    isDisabled: false,
                    procedure: "FRONT_Componente_Combo_Plantas",
                    procedureParams: [userProfile?.ID_Usuario, 'pt-BR', '<#Filtro_ID_Empresa_Destino#>', 'DESTNO', 'NF'],
                    alienated: ["Filtro_ID_Empresa_Destino"]
                  }}
                  preFilter={preFilter}
                  onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                />
              </div>
                <div className="col p-0 form-custom01-filter">
                  <TranspaleStringToComponente
                    elementId={"Numero_NF"}
                    elementProps={{
                      value: '',
                      type: 'Input',
                      placeholder: 'Digitar',
                      title: "Número da Nota",
                      id: "Filtro_Numero_NF"
                    }}
                    preFilter={preFilter}
                    onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                  />              
                </div>
                <div className="col-12 col-md-1 d-flex align-self-end justify-content-end mb-3 pe-0">
                  <button className="btn btn-primary-dark text-white font-size-16 fw-semibold w-auto" onClick={handleFilter} >Pesquisar</button>
                </div>
            </div>
      </div>
      
      {showTable && (
        <div className="col-12">
          <TableSimple
            dataKey={"ID_Registro_Grid"}
            procName={"FRONT_Workspace_DF_OT0040_Tabela_Grid_V16"}
            procParams={`[
              ${userProfile.ID_Usuario},
              "pt-BR",
              1,
              10,
              "<#Filtro_Status_Agendamento#>",
              "<#Filtro_ID_Empresa_Origem#>",
              "<#Filtro_Data_Inicio#>",
              "<#Filtro_Data_Fim#>",
              "<#Filtro_ID_Planta_Origem#>",
              "<#Filtro_ID_Empresa_Destino#>",
              "<#Filtro_ID_Planta_Destino#>",
              "<#Filtro_Numero_Protocolo#>",
              "<#Filtro_Numero_NF#>",
              "<#Filtro_Status_Documento#>"
              ]`}
            columnsList={[
              { field: "Status_Entrega_Agendamento", hasImage: true, header: "Status" },
              { field: "ID_Agendamento", header: "Agendamento", sort: true },
              { field: "Empresa_Origem", hasImage: true, header: "Origem", sort: true },
              { field: "Empresa_Destino", hasImage: true, header: "Destino", sort: true },
              { field: "Data_Agendamento", header: "Data Agendada", sort: true },
              { field: "Numero_NF", header: "Nota Fiscal", sort: true },
              { field: "Valor_Total_NF", header: "Valor Nota Fiscal", sort: true },
              { field: "Status_Entrega_Fisica", header: "Status de Entrega", sort: true },
              { field: "Data_Registro_Entrega", header: "Data de Entrega", sort: true },
              { field: "Coluna_Funcoes", hasImage: true, width: '2%', header: "", sort: false },
            ]}
            enableMinHeight
            triggerOnFilter={triggerOnFilter}
            setTriggerOnFilter={setTriggerOnFilter}
            callbackTriggers={handleTriggers}
            paramsOnFilter={preFilter}
          />
        </div>
      )}
      
      {/* FLOW ATUALIZA STATUS NF */}
      <NotificationModal
        isOpen={modalEditableConfirm}
        type="warning"
        titleCustom={`Deseja atualizar o Status de Entrega de Nota Fiscal?`}
        message={`Ao clicar em 'Confirmar' o Status será ATUALIZADO.`}
        confirmButton
        onClose={() => setModalEditableConfirm(false)}
        onConfirm={handleEditStatusNF}
      />

      <NotificationModal
        isOpen={modalEditableSuccess}
        type="success"
        titleCustom="Sucesso!"
        message={`O Status de Entrega de Nota Fiscal foi atualizado!`}
        onClose={() => {
          setModalEditableSuccess(!modalEditableSuccess)
          setTriggerOnFilter(true)
        }}
      />
      {/* END FLOW ATUALIZA STATUS NF */}

      {/* FLOW DF_OT0042 */}
      <NotificationModal
        isOpen={modalFlowDF_OT0042}
        type="warning"
        titleCustom={`Deseja marcar o Agendamento ${paramsOnItem?.ID_Agendamento} como Pendente?`}
        message={`Ao clicar em 'Confirmar' o Agendamento será marcado como PENDENTE.`}
        confirmButton
        onClose={() => setModalFlowDF_OT0042(false)}
        onConfirm={handleFlowDF_OT0042}
      />

      <NotificationModal
        isOpen={modalFlowDF_OT0042Success}
        type="success"
        titleCustom="Sucesso!"
        message={`O Agendamento ${paramsOnItem?.ID_Agendamento} foi desmarcado como Entregue!`}
        onClose={() => {
          setModalFlowDF_OT0042Success(!modalFlowDF_OT0042Success)
          setTriggerOnFilter(true)
      }}
      />
      {/* END FLOW DF_OT0042 */}

      {/* FLOW DF_OT0044 */}
      <NotificationModal
        isOpen={modalFlowDF_OT0044}
        type="warning"
        titleCustom={`Deseja marcar o Agendamento ${paramsOnItem?.ID_Agendamento} como Entregue?`}
        message={`Ao clicar em 'Confirmar' o Agendamento será CONCLUÍDO.`}
        confirmButton
        onClose={() => setModalFlowDF_OT0044(false)}
        onConfirm={handleFlowDF_OT0044}
      />

      <NotificationModal
        isOpen={modalFlowDF_OT0044Success}
        type="success"
        titleCustom="Sucesso!"
        message={`O Agendamento ${paramsOnItem?.ID_Agendamento} foi marcado como Entregue!`}
        onClose={() => setModalFlowDF_OT0044Success(!modalFlowDF_OT0044Success)}
      />
      {/* END FLOW DF_OT0044 */}
      
      
      {/* MODAL VISUALIZAR STATUS NF */}
      <ModalIframePage 
        openModal={modalViewStatusNF} 
        onClosed={() => setModalViewStatusNF(false)}
        triggerType={triggerType}
      >
        <div className="d-flex align-items-center justify-content-center mb-3">
          <CardFlow flowData={dataViewStatus?.resultset_1? dataViewStatus?.resultset_1.map(item => ({ description: item?.Descricao, name: item?.Nome_Empresa, logo: item?.Logo_Empresa })) : []} />
        </div>
        <div className="d-flex align-items-center mb-3">
          <CardContext data={dataViewStatus?.resultset_2 ? dataViewStatus?.resultset_2.map(item => ({ label: item?.Coluna, value: item?.Valor })) : []} />
        </div>
        <div>
          <p className="text-color-cinza4 font-size-16 fw-semibold mb-1">Observações</p>
          <div className="text-color-cinza4 font-size-16 font-w-400">
            {dataViewStatus?.resultset_3 && dataViewStatus?.resultset_3.length > 0 ? dataViewStatus?.resultset_3[0]?.Observacoes : ''}
          </div>
        </div>
      </ModalIframePage>

      {/* MODAL EDITAR STATUS NF */}
      <ModalIframePage 
        openModal={modalEditStatusNF} 
        onClosed={() => setModalEditStatusNF(false)}
        triggerType={triggerType}
        >
          <div className="d-flex align-items-center justify-content-center mb-3">
            <CardFlow flowData={dataViewStatus?.resultset_1? dataViewStatus?.resultset_1.map(item => ({ description: item?.Descricao, name: item?.Nome_Empresa, logo: item?.Logo_Empresa })) : []} />
          </div>
          <div className="d-flex align-items-center mb-3">
            <CardContext data={dataDF_OT0043?.resultset_2 ? dataDF_OT0043?.resultset_2.map(item => ({ label: item?.Coluna, value: item?.Valor })) : []} />
          </div>
          <div className="d-flex align-items-center gap-3">
              <div className="col-md-6 col-12 form-custom01-filter">
                <TranspaleStringToComponente
                  elementId={"Data"}
                  elementProps={{
                    value: new Date().toLocaleDateString(),
                    type: 'Date',
                    title: "Data",
                    id: "Filtro_Data",
                  }}
                  preFilter={preFilterEditNF}
                  onPreFilter={(filters) => setPreFilterEditNF(state => [{ ...state[0], ...filters }])}
                />
              </div>
              <div className="col">
                <TranspaleStringToComponente
                  elementId={"Status"}
                  elementProps={{
                    value: '',
                    type: 'Combobox',
                    title: "Status",
                    id: "Filtro_Status",
                    procedure: "SRM_Agendamentos_Consulta_Acoes",
                    procedureParams: []
                  }}
                  preFilter={preFilterEditNF}
                  onPreFilter={(filters) => setPreFilterEditNF(state => [{ ...state[0], ...filters }])}
                />
              </div>
          </div>
          <div className="col-12 mb-3">
            <label>Observações</label>
            <textarea className="form-control" rows={5} onChange={(e) => setPreFilterEditNF(state => [{ ...state[0], Observacoes: e.target.value }])}/>
          </div>
          <div className="d-flex justify-content-end gap-2">
            <button onClick={() => setModalEditStatusNF(false)} className="btn bg-primary-dark-inverse border-0 fw-semibold hover-cancel">Cancelar</button>
            <button className="btn btn-primary-dark fw-semibold" onClick={() => setModalEditableConfirm(!modalEditableConfirm)}>Atualizar</button>
          </div>
      </ModalIframePage>

      {/* MODAL TIMELINE */}
      <ModalIframePage 
        openModal={openModalTimeline} 
        onClosed={() => setOpenModalTimeline(false)}
        triggerType={triggerType}
        />
    </div>
  )
}

export default GridBody;
